// Intent: [Trust] [Conversion]
import React from "react";
import { ClipboardCheckIcon, MapPinIcon, MonitorIcon, PanelsTopLeftIcon } from "lucide-react";
const items = [{
  title: "Prepared custom jobs",
  copy: "Built around project-specific information rather than a fixed-size shelf.",
  icon: PanelsTopLeftIcon
}, {
  title: "Browser-based handoff",
  copy: "Prepare on the website, then continue in the branded ordering portal.",
  icon: MonitorIcon
}, {
  title: "Review before submission",
  copy: "Check the available selections and job summary before sending the project.",
  icon: ClipboardCheckIcon
}, {
  title: "Perth, Western Australia",
  copy: "A local market focus with exact service and handover options confirmed per job.",
  icon: MapPinIcon
}];
function TrustStrip() {
  return <section aria-label="What to expect" className="bg-pfpc-navy text-pfpc-offwhite" data-id="element-341" data-mp="3lcdbt0uyiur7">
      <div className="container-shell grid gap-px bg-pfpc-offwhite/12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-342" data-mp="3pa2q2hc60lm1">
        {items.map(({
        title,
        copy,
        icon: Icon
      }) => <div key={title} className="flex min-h-[124px] gap-4 bg-pfpc-navy py-6 sm:px-6 lg:py-7" data-id="element-343" data-mp="2zib96mi8kyuk">
            <span className="grid h-9 w-9 shrink-0 place-items-center border border-pfpc-offwhite/20 text-pfpc-orange" data-id="element-344" data-mp="2velmk2l4grc6">
              <Icon className="h-5 w-5" strokeWidth={2} data-id="element-345" data-mp="2qh3ml1p31mgb" />
            </span>
            <div data-id="element-346" data-mp="2liiop8xazev1"><p className="text-[15px] font-bold leading-5" data-id="element-347" data-mp="2liikewq9ssp8">{title}</p><p className="mt-2 text-[14px] leading-6 text-pfpc-offwhite/72" data-id="element-348" data-mp="3j5983qnynfh7">{copy}</p></div>
          </div>)}
      </div>
    </section>;
}
export { TrustStrip };